import { InputBase } from "@mui/material";
import Sidebar from "components/Sidebar/Siderbar";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SettingChildHeader from "./SettingChildHeader";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { settingsRoutes } from "constants/constants";
import { styled } from "@mui/material/styles";
import SettingHeader from "components/Header/SettingHeader";
import { useGlobalContext } from "context/GlobalContext";
import { usePermissionFlags } from "utils/visionRights";

const SettingLayoutOne = ({ pageName, icon, deIcon }) => {
  const permissions = usePermissions();
  const { showGifIcon } = useGlobalContext();
  const [hasAccess, setHasAccess] = useState(true);
  const location = useLocation();

  const permissionsCheck = ({ permission, key }) => {
    if (permissions && permissions?.isAdmin) {
      return true;
    }
    let allowed = false;

    if (!permission || !permission.permissions) {
      return false;
    }

    if (key === "all") {
      allowed = permission.permissions.some((p) => p.allowed === true);
    } else {
      const searchKey = key.toLowerCase();

      const matchingPermission = permission.permissions.find((p) => p.key && p.key.toLowerCase() === searchKey);

      if (matchingPermission) {
        allowed = matchingPermission.allowed === true;
      }
    }

    return allowed;
  };

  useEffect(() => {
    const basePath = location.pathname.split("/")[1];
    const subPath = location.pathname.split("/")[2];

    if (basePath === "Setting" && subPath) {
      // const findPage = findSpecificPage("Settings", permissions);
      const findPage = findSpecificMenu("Vision Web", permissions);

      if (permissions && findPage) {
        const checkPath = settingsRoutes.find((item) => item.path === subPath)?.check;
        // if (checkPath !== "Orders" && checkPath !== "Rights" && checkPath !== "Limits") {
        if (
          checkPath === "Synchronize" ||
          checkPath === "Main Activity" ||
          checkPath === "Roles" ||
          checkPath === "Rights" ||
          checkPath === "Restricted Designs" ||
          checkPath === "Missing Images" ||
          checkPath === "Rate Master Rights" ||
          checkPath === "Waba Rights" ||
          checkPath === "Design Update" ||
          checkPath === "Update Images" ||
          checkPath === "Labour Rights" ||
          checkPath === "Product USP & Gallery" ||
          checkPath === "My Binny’s Access" ||
          checkPath === "Stock Tray" ||
          checkPath === "Event Type" ||
          checkPath === "Service Request" ||
          checkPath === "Melting Requests" ||
          checkPath === "Orders" ||
          checkPath === "Design Import" ||
          checkPath === "Profile" ||
          checkPath === "Limits" ||
          checkPath === "Archives" ||
          checkPath === "User" ||
          checkPath === "New Rights"
        ) {
          // if (checkPath === "Synchronize") {
          //   findSubPage = Synchronize.some((subMenu) =>
          //     permissionsCheck({
          //       permission: findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), subMenu),
          //       key: "view",
          //     })
          //   );
          // }
          if (checkPath === "Main Activity") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Main Activity"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Restricted Designs") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Restricted Designs"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Roles") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Roles"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Limits") {
            const accessGranted = permissionsCheck({ permission: findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Limits"), key: "all" });
            setHasAccess(accessGranted);
          }
          if (checkPath === "User") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "User"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Archives") {
            const accessGranted = permissionsCheck({ permission: findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Archives"), key: "all" });
            setHasAccess(accessGranted);
          }
          if (checkPath === "Rights") {
            // const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rights"), "view");
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rights"), "view") && permissions?.isAdmin;
            setHasAccess(accessGranted);
          }
          if (checkPath === "Missing Images") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Missing Images"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Design Import") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Design Import"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Profile") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Profile"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Rate Master Rights") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rate Master Rights"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Waba Rights") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Waba Rights"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Design Update") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Design Update"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Update Images") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Update Images"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Labour Rights") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Labour Rights"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Product USP & Gallery") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Product USP and Gallery"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "My Binny’s Access") {
            // const accessGranted = hasAccessPage(findSpecificMenu("My Binny’s App", permissions), "view");
            const accessGranted = permissionsCheck({ permission: findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Client Management"), key: "view" });
            setHasAccess(accessGranted);
          }
          if (checkPath === "Stock Tray") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Stock Tray"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Event Type") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Event Type"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Service Request") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Service Requests"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Melting Requests") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Melting Request"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "Orders") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Quotes"), "view");
            setHasAccess(accessGranted);
          }
          if (checkPath === "New Rights") {
            const accessGranted = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rights"), "view");
            setHasAccess(accessGranted);
            // findSubPage = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Rights"), "view") && permissions?.isAdmin;
          }
        } else {
          // findSubPage = hasAccessSubPage(findSpecificSubMenu(findPage, check), "view");
        }

        // }
      }
    }
  }, [location.pathname, permissions, hasAccess]);

  useEffect(() => {
    return () => setHasAccess(true);
  }, [location.pathname, permissions]);

  return (
    <>
      <div style={{ position: "fixed", color: "white", width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <div style={{ height: "100vh", width: "auto" }}>
          {!showGifIcon ? (
            <>
              <Sidebar />
            </>
          ) : (
            ""
          )}
        </div>
        <div
          style={{
            height: "100vh",
            width: "100%",
            // border: "2px solid red",
            overflowY: "auto",
            scrollbarWidth: "20px" /* Thin scrollbar */,
            scrollbarColor: "#9f9f9f #2c2c2c" /* Black thumb, white track */,
            scrollBehavior: "smooth",
          }}
        >
          <div style={{ position: "sticky", top: 0, zIndex: 999, background: "black", height: "72px", paddingTop: "8px" }}>
            <SettingHeader />
          </div>

          {hasAccess ? (
            <div>
              <div style={{ position: "sticky", top: 72, zIndex: 99, background: "black" }}>
                <SettingChildHeader pageName={pageName} icon={icon} deIcon={deIcon} />
              </div>
              <div
                style={{
                  height: "auto",
                  paddingLeft: "15px",
                  paddingRight: "10px",
                  paddingTop: "0px",
                }}
              >
                <Outlet />
              </div>
            </div>
          ) : (
            <p style={{ color: "red" }}>Access Denide.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default SettingLayoutOne;
